import * as React from 'react';
import { Body1, Box, Color, DisplayPosition, Join, Space } from '@gousto-internal/citrus-react';
import Image from 'next/image';

import { FeaturesColumn } from '../layout/FeaturesColumn';
import { SectionHeading } from '../SectionHeading';
import { FeatureList } from '../FeatureList';
import { FullWidthGrid, FullWidthGridAreas } from '../layout/FullWidthGrid';
import { VideoColumn } from './VideoColumn';

import ChickpeasPattern from '../../../public/assets/patterns/chickpeas.svg';
import VideoPoster from '../../../public/assets/homepage/eating-well-section/video-poster.jpg';
import { GetStartedCTA } from '../GetStartedCTA';

export function EatingWellSection({
  ctaHref,
  mobileHiddenCta,
  ctaOnClick,
}: { ctaHref?: string | null; mobileHiddenCta?: boolean; ctaOnClick?: () => void } = {}) {
  return (
    <section aria-labelledby="eating-well-heading">
      <FullWidthGrid>
        <VideoColumn
          gridArea={[FullWidthGridAreas.Bottom, null, FullWidthGridAreas.Left]}
          position={DisplayPosition.Relative}
        >
          <video
            data-testid="gousto-box-video"
            autoPlay
            loop
            muted
            playsInline
            poster="/assets/homepage/eating-well-section/video-poster.jpg"
            style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute' }}
          >
            <source src="https://media.gousto.ie/videos/hp-video-550px.mp4" />
            <Image src={VideoPoster.src} alt="" fill style={{ objectFit: 'cover' }} />
          </video>
        </VideoColumn>

        <Box
          bg={Color.ColdGrey_800}
          gridArea={[FullWidthGridAreas.Top, null, FullWidthGridAreas.Right]}
          position={DisplayPosition.Relative}
        >
          <Image
            src={ChickpeasPattern.src}
            alt=""
            fill
            style={{ objectFit: 'contain', objectPosition: 'left top' }}
          />
        </Box>

        <FeaturesColumn
          position={DisplayPosition.Relative}
          gridArea={[FullWidthGridAreas.Top, null, FullWidthGridAreas.Right]}
        >
          <Join with={<Space size={[4, null, 6]} />}>
            <SectionHeading color={Color.White} id="eating-well-heading">
              Eating well just got easier
            </SectionHeading>

            <FeatureList name="eating-well-features">
              <Body1 color={Color.White}>
                Unpack fresh, quality ingredients for maximum flavour
              </Body1>
              <Body1 color={Color.White}>
                Cut down on food waste with pre-measured ingredients delivered to your door.
              </Body1>
              <Body1 color={Color.White}>
                We’re proud to support Irish farmers, 100% of our Beef and Chicken is Irish
                <sup>**</sup>
              </Body1>
            </FeatureList>

            <GetStartedCTA href={ctaHref} mobileHidden={mobileHiddenCta} onClick={ctaOnClick} />
          </Join>
        </FeaturesColumn>
      </FullWidthGrid>
    </section>
  );
}
